import Vue from 'vue'

/**
 * 设置基础URL
 */
let base = 'apiv1/hr/announcement'

/**
 * 公告获取条数
 * @param {*} params  /apiv1/hr/announcement/setToRead
 */
export const setToReadAnn = params => {
  return Vue.fetch.post(`${base}/setToRead`, params)
}

/**
 * 公告获取条数
 * @param {*} params
 */
export const getAnnNumber = params => {
  return Vue.fetch.post(`${base}/getRemindInfo`, params).then(data => {
    return data
  })
}

/**
 * 公告添加
 * @param {*} params
 */
export const add = params => {
  return Vue.fetch.post(`${base}/add`, params).then(data => {
    return data
  })
}

/**
 * 公告列表
 * @param {*} params
 */
export const list = params => {
  return Vue.fetch.post(`${base}/list`, params).then(data => {
    return data
  })
}

/**
 * 公告修改
 * @param {*} params
 */
export const update = params => {
  return Vue.fetch.post(`${base}/update`, params).then(data => {
    return data
  })
}

/**
 * 公告删除
 * @param {*} params
 */
export const remove = params => {
  return Vue.fetch.post(`${base}/delete`, params).then(data => {
    return data
  })
}

/**
 * 获取最新
 * @param {*} params
 */
export const lastAdvice = () => {
  return Vue.fetch.post(`${base}/getLast`).then(data => {
    return data
  })
}

/**
 * 公告发布
 * @param {*} params
 */
export const release = params => {
  return Vue.fetch.post(`${base}/release`, params).then(data => {
    return data
  })
}



// WEBPACK FOOTER //
// ./src/services/announcement.js